import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { HomeService } from '../../pages/home/services/home.service';
import { PortalModulesService } from '../services/portal-modules.service';

export const portalModulesResolver: ResolveFn<any> = () => {
  const homeService = inject(HomeService);
  const portalModulesService = inject(PortalModulesService);
  if (portalModulesService.getPortalModules() == null) {
    return homeService.getModules().then(modules => {
      portalModulesService.setPortalModules(modules);
    });
  }
  return portalModulesService.getPortalModules();
};
